import styled from '@rsos/theme/styled';

export const StyledDebugPanel = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 10000;
  background-color: ${({ theme }) => theme.colors.background};
  border: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
  border-radius: 5px;
  padding: 20px;
  min-width: 320px;
  max-width: 400px;
  box-shadow: 0 4px 20px ${({ theme }) => theme.colors.boxShadow};
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const StyledDebugHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  h3 {
    margin: 0;
    color: ${({ theme }) => theme.colors.primaryText};
  }
`;

export const StyledCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.secondaryText};
`;
